<!-- //toolbar component wizard steps and left time indicator -->

<ul *ngIf="currentStep && currentStep.stepId>0" class="new-step-indicator">
	<li *ngFor="let item of [1,2,3,4,5,6]" class="single-step"
	[ngClass]="{
		'active': currentStep.stepId== item,
		'reachable': ((isStepCompleted(item) && currentStep.stepId!= item) || isStepReachble(item))}"
		(click)="getNewStepRouterLink(item)" (keyup.enter)="getNewStepRouterLink(item)" tabindex="{{((isStepCompleted(item) && currentStep.stepId!= item) || isStepReachble(item))}}">
		<div class="number rounded-circle">
			<span>{{item}}</span>
		</div>
		<div class="step-name">{{'STEP-INDICATOR.STEP-'+ item | translate}}</div>
		<div class="arrow">
			<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
				<path d="M10.72 2.21a.771.771 0 0 1 1.06.002c.267.256.29.657.072.939l-.072.08L6.81 8l4.969 4.77a.701.701 0 0 1 .073.938l-.072.081a.773.773 0 0 1-.977.071l-.084-.07-5.5-5.278a.701.701 0 0 1-.073-.94l.073-.082 5.5-5.278z" class="arrow-fill" fill-rule="nonzero"/>
			</svg>			
		</div>
	</li>
</ul>




// WEBPACK FOOTER //
// ./src/app/step-indicator/step-indicator.component.html